module.exports = __webpack_public_path__ + "img/homepage-content-over-image-side.518703a3.png";